import React, { useMemo, useState, useCallback } from "react";
import classNames from "classnames";
import { Form } from "react-bootstrap";
import PropTypes from "prop-types";

import InputGroup from "../../InputGroup";
import DirectoryIcon from "../../../Icon/Directory";
import { InputPropTypes } from "../../../propTypes";
import { FolderTree } from "../../../FolderTreeModal";

const DirectoryInput = ({
  label,
  showLabel,
  disabled,
  readonly,
  input,
  rounded,
  className,
  active,
  error,
  onChange,
  onBlur,
  inputRef,
  value,
  getUserDirectories,
  getUserTrees,
  initialTreePath,
  folderError,
  checkPrinterStatus,
  ...inputProps
}) => {
  const [opened, setOpen] = useState(false);
  const [initialFolders, setInitialFolders] = useState([]);

  // We need this handler to make this work with redux-form. Otherwise
  // even the value is set with controlled function redux-form cant see it
  const onDirectoryPick = useCallback(
    directory => {
      const onChangeFn = input?.onChange || onChange;

      onChangeFn(
        navigator.appVersion.indexOf("Win") !== -1
          ? directory.replace(/\/|\\\/|\\\\/g, "\\")
          : directory
      );
    },
    [input, onChange]
  );

  const onInputChange = useCallback(
    event => {
      const onChangeFn = input?.onChange || onChange;
      onChangeFn(event.target.value);
    },
    [input, onChange]
  );

  const onInputBlur = useCallback(
    event => {
      const trimmedValue = event.target.value.trim();
      const onBlurFn = input?.onBlur || onBlur;
      onBlurFn(trimmedValue);
    },
    [input, onBlur]
  );
  const onClickIcon = useCallback(async () => {
    let isPrinterActive;

    try {
      isPrinterActive = await checkPrinterStatus();
    } catch (e) {
      // NOTE: ignore error, because FolderTree.Modal won't open
    }

    if (isPrinterActive) {
      // NOTE: errors from getUserDirectories are handled from outside
      const initialFolders = await getUserDirectories();
      if (initialFolders) {
        setInitialFolders(initialFolders);
        setOpen(true);
      }
    }
  }, [checkPrinterStatus, getUserDirectories]);

  const append = useMemo(() => {
    return (
      <div className="icon" onClick={onClickIcon}>
        <DirectoryIcon />
      </div>
    );
  }, [onClickIcon]);

  return (
    <>
      <InputGroup append={append}>
        <Form.Control
          as={"input"}
          type="text"
          ref={inputRef}
          {...inputProps}
          {...input}
          placeholder={active ? "" : label}
          disabled={disabled}
          readOnly={readonly}
          onDrop={e => e.preventDefault()}
          className={classNames(
            "mydpd-input mydpd-form-control",
            "pr-4",
            rounded && "rounded",
            className
          )}
          onChange={onInputChange}
          onBlur={onInputBlur}
          value={value}
        />
      </InputGroup>
      <FolderTree.Modal
        show={opened}
        onClose={() => setOpen(false)}
        getUserDirectories={getUserDirectories}
        getUserTrees={getUserTrees}
        onDirectoryPick={onDirectoryPick}
        initialTreePath={initialTreePath}
        initialFolders={initialFolders}
        setInitialFolders={setInitialFolders}
      />
    </>
  );
};

DirectoryInput.propTypes = {
  initialTreePath: PropTypes.string.isRequired,
  getUserDirectories: PropTypes.func,
  getUserTrees: PropTypes.func,
  folderError: PropTypes.object,
  ...InputPropTypes,
};

export default DirectoryInput;
